<template>
  <div class="home page noselect">

    <div class="spacer-25"></div>

    <MyAbholzeiten></MyAbholzeiten>

    <fix-basket></fix-basket>

    <!--        </div>-->

    <!--        </div>-->
  </div>
</template>

<script>
// @ is an alias to /src
// import {ebus} from '../vendor/ebus';
import store from '../store/store'
// import * as qconst from '../vendor/qconstants';
// import * as util from '../vendor/util'
// import * as firebaseUtil from '../firebase/firebaseUtil'


// import AppHead from "../components/AppHead";
// import MySlider2 from "../components/MySlider2";
// import CategoryCard from "../components/CategoryCard";
// import CardLieferzeiten from "../cards/CardLieferzeiten";
// import CardAbholung from "../cards/CardAbholung";
// import CardOpeningHours from "../cards/CardOpeningHours";
// import {offerMixin} from "../mixins/offerMixin";
// import CardOnlineShop from "../cards/CardOnlineShop";
import FixBasket from "../components/FixBasket";
// import SliderCategories from "../components/SliderCategories";
// import SliderLotionen from "../components/SliderLotionen";
// import SliderDeko from "../components/SliderDeko";
import SortimentCards from "../components/SortimentCards";
import Oeffnungszeiten from "../components/oeffnungszeiten";
import Zahlungsarten from "../components/Zahlungsarten";
import MyAbholzeiten from "../components/MyAbholzeiten";
// import SliderAktionen from "../components/SliderAktionen";
// import CardSortiment from "../cards/CardSortiment";
// import CardNeuigkeiten from "../cards/CardNeuigkeiten";
// import CardCoupons from "../cards/CardCoupons";
// import SortimentCards from "../components/SortimentCards";
// import SortimentCards from "../components/SortimentCards";
// import CardSortimentButtons from "../cards/CardSortimentButtons";

export default {
  name: 'Home',
  // mixins: [offerMixin],
  components: {
    MyAbholzeiten,
    Zahlungsarten,
    Oeffnungszeiten,
    // SliderAktionen,
    // SortimentCards,
    // SliderDeko,
    // SliderLotionen,
    // SliderCategories,
    // CardCoupons,
    // SortimentCards,
    // CardNeuigkeiten,
    // SortimentCards,
    // CardSortimentButtons,
    // CardSortiment,
    FixBasket,
    // CardOpeningHours,
    // CardAbholung,
    // CardLieferzeiten,
    // CardOnlineShop,
    // MySlider2,
    // CategoryCard,
    // AppHead,
  },
  data() {
    return {}
  },
  computed: {
    // numberOfFavs() {
    //     let favFoods = [];
    //     let favs = util.cloneMe(store.getters.favFoods);
    //     for (let favFood of favs) {
    //         let foodItem = store.getters.getFoodById(favFood.id);
    //         if (!foodItem) {
    //             //ignore items that do not exist
    //             continue;
    //         }
    //         // if ('image' in foodItem) {
    //         //     favFood.image = foodItem.image;
    //         // }
    //         favFoods.push(favFood);
    //     }
    //     // if (favFoods.length === 0) {
    //     let lsFavFoods = this.$ls.get('favFoods');
    //     if (lsFavFoods) {
    //         let fv = JSON.parse(lsFavFoods);
    //         for (let v of fv) {
    //             //ignore items that already exist
    //             if (this.containsItemId(favFoods, v.id)) {
    //                 continue
    //             }
    //
    //             let foodItem = store.getters.getFoodById(v.id);
    //             if (!foodItem) {
    //                 //ignore items that do not exist
    //                 continue;
    //             }
    //             // if ('image' in foodItem) {
    //             //     v.image = foodItem.image;
    //             // }
    //             favFoods.push(v);
    //         }
    //     }
    //     return favFoods.length;
    // },
    // unfilteredCategories() {
    //     return util.cloneMe(this.foodCategories);
    // },
  },
  // created() {
  // },
  // activated() {
  //     this.init();
  //     // ebus.$emit('showScrollDown', true);
  //     // let sd = document.getElementById('scrollDown');
  //     // sd.style.opacity = '0';
  //     // sd.style.pointerEvents = 'none';
  //     // // logPageView('Home')
  //     // if (window.innerWidth < 800) {
  //     //     window.addEventListener('scroll', this.handleScroll);
  //     // }
  // },
  // destroyed() {
  //     // let sd = document.getElementById('scrollDown');
  //     // sd.style.opacity = '1';
  //     // sd.style.pointerEvents = 'all';
  //     //
  //     // window.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    chooseUsecase(uc) {
      // store.commit('selectedUsecase', uc);
      this.gotoSortiment();
    },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    // handleScroll(event) {
    //     // console.log('Scroll: ' + (window.scrollY + window.innerHeight) + ' from ' + document.body.clientHeight);
    //
    //     try {
    //         document.getElementById('away').style.opacity = 1 - (window.scrollY / 250);
    //     } catch (e) {
    //         console.log('Error on scroll: ' + e.message);
    //     }
    //
    // },
    // updateUserName() {
    //     try {
    //         this.userName = '';
    //         // let user = firebaseUtil.getUser();
    //         // if (user && user.displayName && user.displayName.length > 3) {
    //         //     this.userName = user.displayName;
    //         // }
    //     } catch (e) {
    //
    //     }
    // },
    init() {
      // let foodCats = util.cloneMe(store.getters.foodMenu);
      // // for (let fcat of foodCats) {
      // //     if (!fcat.items) {
      // //         continue;
      // //     }
      // //     for (let item of fcat.items) {
      // //         let offerAndItem = store.getters.getOfferByItemId(item.id);
      // //         // item.offered = !!offerAndItem;
      // //         // if (!!offerAndItem) {
      // //         //     item.offerId = offerAndItem.offer.id;
      // //         // }
      // //         this.applyOfferAndPrices(item, offerAndItem);
      // //     }
      // // }
      // this.foodCategories = foodCats;
    },
    // containsItemId(items, id) {
    //     for (let item of items) {
    //         if (item.id === id) {
    //             return true;
    //         }
    //     }
    //     return false;
    // },


  }

}
</script>
<style scoped lang="scss">
@import '../styles/base';

.myBox {
  border: 3px solid $accent;
  padding: 2.5vw;
  margin: 10px;
  border-radius: $box-border-radius;
}

/*.home.page {*/
/*    padding-bottom: 0;*/
/*}*/


/*.home ::v-deep .cardContent .v-card__text {*/
/*    //color: $accent;*/
/*}*/

/*<!--.homeCard {-->*/
/*<!--    text-align: center;-->*/

/*<!--    background-color: $color-primary;-->*/

/*<!--    position: relative;-->*/

/*<!--    i {-->*/
/*<!--        //color: $accent !important;-->*/
/*<!--    }-->*/
/*<!--}-->*/

/*.home ::v-deep .cardContent {*/
/*    //@extend .cardGradient;*/

/*    z-index: 3;*/
/*    height: 100%;*/

/*    background-color: transparent;*/

/*    background-position: center;*/
/*    background-repeat: no-repeat;*/
/*    background-size: contain;*/
/*    background-image: url('../assets/square-trans4-opti.png');*/
/*    !*backdrop-filter: opacity(30%);*!*/
/*}*/

/*.home .tablet ::v-deep .cardContent {*/
/*    background-size: cover;*/
/*}*/


/*.home{*/
/*    */
/*}*/

/*.home .mobile {*/
/*    background-color: black;*/
/*    //background-color: #111;*/
/*}*/

/*.appFiliale {*/
/*    width: 100%;*/
/*    max-width: 300px;*/
/*}*/

/*.bald {*/
/*    background-color: #B27C4F;*/
/*    //font-weight: 700;*/
/*    !* font-size: 1.1em; *!*/
/*    padding: 1px 32px;*/
/*    margin-top: 15px;*/
/*    display: inline-block;*/
/*    color: white;*/
/*}*/


/*.cat-item {*/
/*    width: 40%;*/
/*}*/

/*.cat-item:nth-child(3n+1) {*/
/*    width: 60%;*/
/*}*/

/*.cat-item:nth-child(4n+1) {*/
/*    width: 60%;*/
/*}*/

/*.cat-item:nth-child(3n+8) {*/
/*    width: 60%;*/
/*}*/

/*.cat-item:nth-child(5n+7) {*/
/*    width: 40%;*/
/*}*/

/*.cat-item:nth-child(1n+9) {*/
/*    width: 50%;*/
/*}*/

/*.mHero {*/
/*    padding-top: 65px;*/
/*    position: relative;*/
/*    !*background-position: top center; //focused corner is bottom left*!*/
/*    !*background-repeat: no-repeat;*!*/
/*    !*background-size: cover;*!*/
/*    !*background-image: url('../assets/bg2.jpg');*!*/
/*    !*filter: brightness(115%);*!*/

/*    !*.fixBg {*!*/
/*    !*    position: fixed;*!*/
/*    !*    top: 65px;*!*/
/*    !*    left: 0;*!*/
/*    !*    height: 100vh;*!*/
/*    !*    background-color: black;*!*/
/*    !*    background-position: top center; //focused corner is bottom left*!*/
/*    !*    background-repeat: no-repeat;*!*/
/*    !*    background-size: cover;*!*/
/*    !*    background-image: url('../assets/bg2.jpg');*!*/
/*    !*    backdrop-filter: brightness(115%);*!*/
/*    !*}*!*/

/*}*/

/*.mHero ::v-deep .v-parallax__image {*/
/*    width: 100%;*/
/*    min-height: auto;*/
/*    bottom: 43vh;*/
/*    !*bottom: 300px;*!*/
/*}*/


/*.mobile {*/
/*    !*.hero {*!*/
/*    !*    margin-top: 60px;*!*/
/*    !*    padding: 25px 0 35px 0;*!*/
/*    !*    !*background-position: center;*!*!*/
/*    !*    background-position: top center; //focused corner is bottom left*!*/
/*    !*    background-repeat: no-repeat;*!*/
/*    !*    background-size: cover;*!*/
/*    !*    background-image: url('../assets/bg2.jpg');*!*/
/*    !*    filter: brightness(115%);*!*/

/*    !*    //            clip-path: ellipse(140% 100% at 40% -1%);*!*/
/*    !*    //clip-path: polygon( 0 0, !* left top *! 100% 0, !* right top *! 100% 90%, !* right bottom *! 0 100% !* left bottom *! );*!*/
/*    !*}*!*/

/*    !*.ct {*!*/
/*    !*    display: flex;*!*/
/*    !*    padding: 2.2vw;*!*/
/*    !*    !*font-size: 1.1em;*!*!*/
/*    !*    background-color: rgba(white, 0.75);*!*/
/*    !*    border-radius: 6px;*!*/
/*    !*    margin-bottom: 15px;*!*/

/*    !*    .a {*!*/
/*    !*        flex: 1 1 80%;*!*/
/*    !*    }*!*/

/*    !*    .head {*!*/
/*    !*        font-size: 1.2em;*!*/
/*    !*    }*!*/

/*    !*    .b {*!*/
/*    !*        flex: 1 1 20%;*!*/
/*    !*        text-align: center;*!*/
/*    !*        align-self: center;*!*/
/*    !*    }*!*/

/*    !*    .b ::v-deep i {*!*/
/*    !*        font-size: 45px;*!*/
/*    !*    }*!*/
/*    !*}*!*/
/*}*/

/*.cat-item:nth-child(2n+1){*/
/*    width: auto;*/
/*}*/
</style>
